import React, { useState } from 'react';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

import useDebouncedCallback from '../../../utilities/customHooks/useDebouncedCallback';

interface Props {
  currentSearch: string;
  hasSearchSign?: boolean;
  placeholder?: string;
  onSearch: (searchValue: string) => void;
}

const Search: React.FC<Props> = props => {
  const [searchInput, setSearchInput] = useState(props.currentSearch);

  const onSearch = useDebouncedCallback((searchValue: string) => {
    props.onSearch(searchValue);
  }, 300);

  const onChange = (event: React.FormEvent<HTMLInputElement>) => {
    const searchValue = event.currentTarget.value;
    setSearchInput(searchValue);
    onSearch(searchValue);
  };

  return (
    <InputGroup width="16rem">
      {props.hasSearchSign && (
        <InputLeftElement>
          <FontAwesomeIcon icon={faSearch} />
        </InputLeftElement>
      )}

      <Input
        data-selector="search-box"
        name={'search'}
        value={searchInput}
        onChange={onChange}
        placeholder={props.placeholder ? props.placeholder : 'Search'}
      />
    </InputGroup>
  );
};

export default Search;
